import { render, staticRenderFns } from "./DetailsTabs.vue?vue&type=template&id=1b1f1d8c&scoped=true"
import script from "./DetailsTabs.vue?vue&type=script&lang=js"
export * from "./DetailsTabs.vue?vue&type=script&lang=js"
import style0 from "./DetailsTabs.vue?vue&type=style&index=0&id=1b1f1d8c&prod&lang=scss"
import style1 from "./DetailsTabs.vue?vue&type=style&index=1&id=1b1f1d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1f1d8c",
  null
  
)

export default component.exports